import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { innerSVG } from '@/assets/raw/RecyclingCenterIcon';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "100%",
    height: "100%",
    version: "1.1",
    viewBox: "0 0 24.051 23.191",
    xmlns: "http://www.w3.org/2000/svg",
    innerHTML: _unref(innerSVG)
  }, null, 8, _hoisted_1))
}
}

})